import React from 'react';

export default () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.01773 11.2774L12.8142 4.51681L11.7523 3.42526L6.01773 9.12948L3.32745 6.45343L2.2655 7.50977L6.01773 11.2774ZM2.1947 2.22808C3.68143 0.749202 5.46315 0.00976562 7.53986 0.00976562C9.61657 0.00976562 11.3865 0.749202 12.8496 2.22808C14.3364 3.68347 15.0797 5.44404 15.0797 7.50977C15.0797 9.57549 14.3364 11.3478 12.8496 12.8267C11.3865 14.2821 9.61657 15.0098 7.53986 15.0098C5.46315 15.0098 3.68143 14.2821 2.1947 12.8267C0.731567 11.3478 0 9.57549 0 7.50977C0 5.44404 0.731567 3.68347 2.1947 2.22808Z" fill="currentColor" />
  </svg>
);
